/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Achievement_WeekendInputs */

const en_us2_achievement_weekend = /** @type {(inputs: Achievement_WeekendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekender`)
};

const pt_br2_achievement_weekend = /** @type {(inputs: Achievement_WeekendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fim de semana`)
};

const es_419_achievement_weekend = /** @type {(inputs: Achievement_WeekendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fin de semana`)
};

const pt_pt2_achievement_weekend = /** @type {(inputs: Achievement_WeekendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fim de semana`)
};

const fr_fr2_achievement_weekend = /** @type {(inputs: Achievement_WeekendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Week-end`)
};

const de_de2_achievement_weekend = /** @type {(inputs: Achievement_WeekendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wochenendler`)
};

const it_it2_achievement_weekend = /** @type {(inputs: Achievement_WeekendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weekend`)
};

/**
* | output |
* | --- |
* | "Weekender" |
*
* @param {Achievement_WeekendInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const achievement_weekend = /** @type {((inputs?: Achievement_WeekendInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Achievement_WeekendInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_achievement_weekend(inputs)
	if (locale === "es-419") return es_419_achievement_weekend(inputs)
	if (locale === "pt-PT") return pt_pt2_achievement_weekend(inputs)
	if (locale === "fr-FR") return fr_fr2_achievement_weekend(inputs)
	if (locale === "de-DE") return de_de2_achievement_weekend(inputs)
	if (locale === "it-IT") return it_it2_achievement_weekend(inputs)
	return en_us2_achievement_weekend(inputs)
});
export { achievement_weekend as "achievement.weekend" }